import apiClient from '@/services/axios'

export async function put(id, payload) {
  var response = await apiClient.put('/rewards/' + id, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update reward.')
}